import { render, staticRenderFns } from "./ManterPeticao.vue?vue&type=template&id=b2cac87c&scoped=true&"
import script from "./ManterPeticao.vue?vue&type=script&lang=js&"
export * from "./ManterPeticao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cac87c",
  null
  
)

export default component.exports